if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"diagnostics","remotes":[{"alias":"anomaly_detection","name":"anomaly_detection","entry":"/anomaly-detection/anomaly_detection_entrypoint.js","shareScope":"default","externalType":"script"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return /^(179|403)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"anomaly_detection":[{"alias":"anomaly_detection","name":"anomaly_detection","entry":"/anomaly-detection/anomaly_detection_entrypoint.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}